import { render, staticRenderFns } from "./ContactDetailsModal.vue?vue&type=template&id=8122a924&scoped=true&"
import script from "./ContactDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailsModal.vue?vue&type=style&index=0&id=8122a924&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8122a924",
  null
  
)

export default component.exports